import { combineReducers } from 'redux';
import { torquePayReducer } from './torque-pay-reducer';
import { twilioReducer } from './twilio-reducer';
import { nexPartreducer } from './nex-part-reducer';
import { partTechReducer } from './part-tech-reducer';

const integrationsRootReducer = combineReducers({
  torquePay: torquePayReducer,
  twilio: twilioReducer,
  nexPart: nexPartreducer,
  partTech: partTechReducer,
});

export default integrationsRootReducer;
